export default __webpack_public_path__ + "static/media/signatureHeader.8cdc1502.svg";